import { SupplementalRuleIdentifierType } from './SupplementalRuleIdentifierType';

export const SupplementalRuleIdentifierTypeOptions = [
    {
        id: SupplementalRuleIdentifierType.EmployeeUnitPerYearEvaluation,
        name: 'EmployeeUnitPerYearEvaluation',
    },
];
